import { render, staticRenderFns } from "./ChatSystemSidebarContent.vue?vue&type=template&id=3549c400&"
import script from "./ChatSystemSidebarContent.vue?vue&type=script&lang=js&"
export * from "./ChatSystemSidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./ChatSystemSidebarContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VTextarea})
